export default [
  {
    path: '/trips',
    name: 'trips',
    component: () => import('@/views/trips/pages/TripsList.vue'),
    meta: {
      resource: 'trips',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Trips',
      breadcrumb: [
        {
          text: 'Trips',
          active: true,
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/bookings',
    name: 'bookings-list',
    component: () => import('@/views/trips/pages/Bookings.vue'),
    meta: {
      resource: 'schedules',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Bookings',
      breadcrumb: [
        {
          text: 'Bookings',
          active: true,
        },
      ],
    },
  },
  {
    path: '/bookings/:id',
    name: 'booking-details',
    component: () => import('@/views/trips/pages/BookingDetails.vue'),
    meta: {
      resource: 'schedules',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Booking Detail',
      breadcrumb: [
        {
          text: 'Bookings',
          to: '/bookings',
        },
      ],
    },
  },
  {
    path: '/trips/new',
    name: 'trips-new',
    component: () => import('@/views/trips/pages/CreateTrip.vue'),
    meta: {
      resource: 'create-trip',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Create Trip',
      // breadcrumb: [
      //   {
      //     text: 'Trips',
      //     active: true,
      //   },
      // ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/trips/:id',
    name: 'trip-details',
    component: () => import('@/views/trips/pages/TripDetails.vue'),
    meta: {
      resource: 'trips',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Trip Details',
      breadcrumb: [
        {
          text: 'Trips',
          to: '/trips',
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/heatmap-polygons',
    name: 'heatmap-polygons',
    component: () => import('@/views/trips/pages/HeatmapPolygons.vue'),
    meta: {
      resource: 'heatmap',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Heatmap Polygons',
      breadcrumb: [
        {
          text: 'Heatmap Polygons',
          active: true,
        },
      ],
    },
  },
]
